/*
 * @Author: WYX
 * @Date: 2019/12/26
 * @LastEditTime: 2021-04-20 14:40:09
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\resourceCenter\directive\resourceList\resourceListCard\resourceListCard.js
 * @Description: 稿件标签指令模块
 */
angular
    .module('resourceListCardModule', [])
    .directive('resourceListCard', [
        '$stateParams',
        'messagePublishService',
        'mrApiService',
        'modalDialog',
        'localStorageService',
        '$modal',
        '$q',
        '$timeout',
        '$sessionStorage',
        '$window',
        function ($stateParams, messagePublishService, mrApiService, modalDialog, localStorageService, $modal, $q, $timeout, $sessionStorage, $window) {
            return {
                scope: true, // 继承作用域
                restrict: 'EA',
                templateUrl: './resourceCenter/directive/resourceList/resourceListCard/resourceListCard.html',
                replace: true,
                transclude: true,
                link: function ($scope, $element, $attr) {
                    initStatus();
                    initData();

                    /**
                     * [initStatus description]初始化状态
                     * @return {[type]} [description]
                     */
                    function initStatus() {
                        $scope.status = {
                            // 是否选中
                            isCheck: false,
                            // 是否展示工具栏
                            isShowMore: null,
                            resourcetype: $stateParams.resourcetype,
                            listIndex: Number($attr.index),
                            isShowAuditingStatus: false,
                            isShowRenameInput: false,
                            toolBarDirect: 'left',
                            isShowCheckSuccess: false, // 是否显示三鉴成功信息
                            audioVideoConfigInfo: {},
                        };
                        $scope.status.toolBarDirect = getToolBarDirect($scope.status.listIndex);
                        $scope.data = {
                            audidingErrors: null,
                            reFilename: $scope.item.resourcetitle,
                        };
                    }

                    /**
                     * [getToolBarDirect 工具条和浮窗浮动方向]
                     * @param   {[type]}  index  [index description]
                     * @return  {[type]}         [return description]
                     */
                    function getToolBarDirect(index) {
                        return ++index % 4 === 0 ? 'left' : 'right';
                    }

                    /**
                     * [initData description]初始化数据
                     * @return  {[type]}  [return description]
                     */
                    function initData() {
                        messagePublishService.subscribe(
                            'materialResourceSelectAll',
                            function (event, data) {
                                $scope.status.isCheck = data;
                            },
                            $scope
                        );
                    }

                    /**
                     * [initAuddingStatus 初始化审核不通过的原因]
                     * @return  {[type]}  [return description]
                     */
                    function initAuddingStatus() {
                        if ($scope.item.resourcestatus === -1) {
                            if ($scope.data.audidingErrors && $scope.data.audidingErrors.length > 0) {
                                $scope.status.isShowAuditingStatus = true;
                            } else {
                                let param = {
                                    resourceid: $scope.item.resourceid,
                                    tenantId: $sessionStorage.get('curUserInfo').TENANTID,
                                    userName: $sessionStorage.get('curUserInfo').USERNAME,
                                };
                                mrApiService.getErrorMsg(param).then(function (data) {
                                    if (data.code === '200') {
                                        $scope.data.audidingErrors = data.datas;
                                        $scope.status.isShowAuditingStatus = true;
                                    }
                                });
                            }
                        }
                    }

                    $scope.updateAudidingErrors = function (data) {
                        $scope.data.audidingErrors = data;
                    };

                    $scope.showAuditing = function () {
                        initAuddingStatus();
                    };

                    /**
                     * [clickHide description]点击其他位置关闭工具栏
                     *
                     * @return  {[type]}  [return description]
                     */
                    function clickHide() {
                        $(document).on('click', function (e) {
                            var target = e.target || e.srcElement;
                            var select = document.getElementsByClassName('resource-tool-label')[$attr.index];
                            if (target !== select) {
                                $scope.status.isShowMore = $scope.status.isShowMore === null ? null : false;
                                $scope.$apply();
                            }
                        });
                    }

                    /**
                     * [changeCheck description]改变选中状态
                     * @return  {[type]}  [return description]
                     */
                    $scope.changeCheck = function () {
                        $scope.status.isCheck = !$scope.status.isCheck;
                        syncCheckList();
                    };

                    /**
                     * [syncCheckList 同步到父级选择数组]
                     * @return  {[type]}  [return description]
                     */
                    function syncCheckList() {
                        if ($scope.status.isCheck) {
                            $scope.selectedArray.push($scope.items[$attr.index]);
                        } else {
                            $scope.selectedArray.forEach(function (element, index) {
                                if (element.relationid === $scope.items[$attr.index].relationid) {
                                    $scope.selectedArray.splice(index, 1);
                                }
                            });
                        }
                    }

                    /**
                     * [rename 媒资重命名]
                     * @return  {[type]}  [return description]
                     */
                    $scope.rename = function () {
                        $scope.status.isShowRenameInput = true;
                        $timeout(function () {
                            var renameInput = $element.find('.card-title').find('input')[0];
                            renameInput.focus();
                            renameInput.select();
                        }, 0);
                    };

                    /**
                     * [getTakeRecords 获取媒资取签记录]
                     * @param   {[type]}  item  [item description]
                     * @return  {[type]}        [return description]
                     */
                    $scope.getTakeRecords = function (item) {
                        let options = {
                            mrType: $scope.basicalStatus.commonParams.mrType,
                            mainResourceType: $scope.basicalStatus.commonParams.mainResourceType,
                            relationId: item.relationid,
                            operation: 'fetch',
                        };
                        getTakeRecords(options);
                    };

                    /**
                     * [hasTakeRecordsRights 是否有获取媒资取签记录的权限]
                     *
                     * @param   {[type]}  item  [item description]
                     *
                     * @return  {[type]}        [return description]
                     */
                    $scope.hasTakeRecordsRights = function (item) {
                        return (
                            $scope.basicalStatus.commonParams.mainResourceType !== '3' &&
                            item.relationtype === 2 &&
                            $scope.basicalStatus.checkList &&
                            $scope.basicalStatus.checkList.chakan
                        );
                    };

                    /**
                     * [getTakeRecords 获取素材取签日志]
                     *
                     * @param   {[type]}  options  [options description]
                     *
                     * @return  {[type]}           [return description]
                     */
                    function getTakeRecords(options) {
                        var deffer = $q.defer();
                        var modalInstance = $modal.open({
                            templateUrl: './resourceCenter/materialResource/service/mediaTakeRecords/take_records_tpl.html',
                            windowClass: 'media_take_records',
                            backdrop: false,
                            resolve: {
                                options: function () {
                                    return options;
                                },
                            },
                            controller: 'mediaTakeRecordCtrl',
                        });
                        modalInstance.result.then(function (result) {
                            if (!options.isResolve && options.success) {
                                options.success(result);
                            } else {
                                deffer.resolve(result);
                            }
                        });
                        return deffer.promise;
                    }

                    /**
                     * [submitRename 确认重命名操作]
                     *
                     * @return  {[type]}  [return description]
                     */
                    $scope.submitRename = function () {
                        if ($scope.data.reFilename === '') {
                            modalDialog.alertType('提示', '名称不能为空', 'warning');
                        }
                        if ($scope.data.reFilename === $scope.item.resourcetitle) {
                            $scope.status.isShowRenameInput = false;
                            return;
                        } else {
                            submitRename();
                        }
                    };

                    /**
                     * [hasRenameRight 是否有重命名权限]
                     *
                     * @param   {[type]}  item  [item 当前媒资]
                     *
                     * @return  {[type]}        [return description]
                     */
                    $scope.hasRenameRight = function (item) {
                        return (
                            ($scope.basicalStatus.ispersonalmaterial && $scope.basicalStatus.checkList && $scope.basicalStatus.checkList.chakan) ||
                            ($scope.basicalStatus.checkList && $scope.basicalStatus.checkList.edit)
                        );
                    };

                    /**
                     * [isShowTool 是否显示工具条触发按钮]
                     * @param   {[type]}  item  [item description]
                     * @return  {[type]}        [return description]
                     */
                    $scope.isShowTool = function (item) {
                        const MATERIALTYPE = 2;
                        if (item.relationtype === MATERIALTYPE) {
                            if (item.resourcestatus === $scope.basicalStatus.materialStatus.formatFail.value) {
                                return false;
                            }
                            if (
                                $scope.basicalStatus.checkList &&
                                !$scope.basicalStatus.checkList.edit &&
                                !$scope.basicalStatus.checkList.chakan &&
                                !$scope.basicalStatus.checkList.delete
                            ) {
                                return false;
                            }
                        } else {
                            if ($scope.basicalStatus.commonParams.mrType !== 'personal') {
                                if ($scope.basicalStatus.checkList && !$scope.basicalStatus.checkList.edit && !$scope.basicalStatus.checkList.delete) {
                                    return false;
                                }
                            }
                        }
                        return true;
                    };

                    /**
                     * [submitRename 提交重命名请求]
                     *
                     * @return  {[type]}  [return description]
                     */
                    function submitRename() {
                        let params = {
                            fileName: $scope.data.reFilename,
                            id: $scope.item.relationid,
                        };
                        mrApiService.rename(angular.extend({}, $scope.basicalStatus.commonParams, params)).then(
                            function (data) {
                                if (data.code === '200') {
                                    modalDialog.alertType('', '重命名成功', 'success', false, function () {
                                        $scope.requestData();
                                    });
                                } else {
                                    modalDialog.alertType('错误', '重命名失败', 'errro');
                                    $scope.data.reFilename = $scope.item.resourcetitle;
                                }
                                $scope.status.isShowRenameInput = false;
                            },
                            function (data) {
                                modalDialog.alertType('错误', '重命名失败', 'errro');
                                $scope.data.reFilename = $scope.item.resourcetitle;
                            }
                        );
                    }

                    /**
                     * [changeCheck description]改变工具栏状态
                     *
                     * @return  {[type]}  [return description]
                     */
                    $scope.changeShowTool = function () {
                        if ($scope.status.isShowMore) {
                            $scope.status.isShowMore = !$scope.status.isShowMore;
                            $(document).off('click');
                        } else {
                            $scope.status.isShowMore = true;
                            clickHide();
                        }
                    };

                    /**
                     * [hasRights 工具栏按钮权限判断]
                     *
                     * @param   {[type]}  item          [item 当前项目]
                     * @param   {[type]}  resourcetype  [resourcetype 媒资类型]
                     * @param   {[type]}  type          [type 操作类型]
                     *
                     * @return  {[type]}                [return description]
                     */
                    $scope.hasRights = function (item, resourcetype, type) {
                        let currentResourceType = parseInt($scope.basicalStatus.commonParams.mainResourceType);
                        let itemResourceType = parseInt(resourcetype);
                        if ($scope.basicalStatus.commonParams.mrType === 'personal') {
                            return $scope.basicalStatus.checkList && $scope.basicalStatus.checkList.chakan;
                        } else {
                            return currentResourceType === itemResourceType && $scope.basicalStatus.checkList && $scope.basicalStatus.checkList[type];
                        }
                    };

                    /**
                     * [changeVideoMessage description]改变视频信息修改弹窗
                     *
                     * @return  {[type]}  [return description]
                     */
                    $scope.changeMessage = function () {
                        $scope.basicalStatus.showMessage = true;
                        messagePublishService.publish('changeMessageItem', $scope.items[$attr.index]);
                    };

                    /**
                     * [goPreview description]跳转至细览页
                     *
                     * @param   {[type]}  item  [item description]
                     *
                     * @return  {[type]}        [return description]
                     */
                    $scope.goPreview = function (item) {
                        if (item.resourcestatus !== 1) {
                            return;
                        }
                        if (item.relationtype !== 0) {
                            let mrtype = $scope.basicalStatus.commonParams.mrType;
                            let resourcetype = $scope.basicalStatus.commonParams.mainResourceType;
                            let relationid = item.relationid;
                            let url = `#/preview?mrtype=${mrtype}&relationid=${relationid}&resourcetype=${resourcetype}`;
                            window.open(url, '_blank');
                        }
                    };

                    /**
                     * [deleteMaterial 删除素材]
                     *
                     * @param   {[type]}  item  [item description]
                     *
                     * @return  {[type]}        [return description]
                     */
                    $scope.deleteMaterial = function (item) {
                        let tips =
                            item.relationtype === 0 ? '如果删除文件夹，文件夹内的素材会被全部删除，确认删除吗？' : '该素材将被删除，是否确认删除';
                        modalDialog.confirmModal(
                            '提示信息',
                            tips,
                            function () {
                                let param = angular.extend({}, $scope.basicalStatus.commonParams, { relationIds: item.relationid });
                                mrApiService.deleteMaterial(param).then(function (data) {
                                    if (data.code === '200') {
                                        modalDialog.alertType('', '删除成功', 'success', false, function () {
                                            $scope.requestData();
                                        });
                                    } else {
                                        modalDialog.alertType(data.code, data.msg, 'error', false);
                                    }
                                });
                            },
                            () => {
                                return;
                            }
                        );
                    };

                    /**
                     * [openFolder 进入文件夹]
                     *
                     * @return  {[type]}  [return description]
                     */
                    $scope.openFolder = function () {
                        // 缓存当前海贝检索参数
                        localStorageService.set('materialSearchParams', $scope.basicalStatus.searchParams);
                        $scope.basicalStatus.currentFolderId = $scope.item.relationid;
                        $scope.basicalStatus.isInFolder = true;
                        $scope.getFolderMaterial();
                    };

                    /**
                     * [openText 文字素材点击]
                     *
                     * @return  {[type]}  [return description]
                     */
                    $scope.openText = function () {
                        if ($scope.item.relationtype === 0) {
                            $scope.openFolder();
                        } else {
                            openFilePreview($scope.item, function () { });
                        }
                    };

                    /**
                     * [fastEditVideo 视频快编]
                     *
                     * @param   {[type]}  item  [item description]
                     *
                     * @return  {[type]}        [return description]
                     */
                    $scope.fastEditVideo = function (item) {
                        mrApiService
                            .qEditMessage({
                                mrType: $scope.basicalStatus.commonParams.mrType,
                                mainResourceType: $scope.basicalStatus.commonParams.mainResourceType,
                                relationId: item.relationid,
                            })
                            .then((response) => {
                                if (response.code === '200') {
                                    window.open(response.datas.qurl); // 打开快编页面
                                } else {
                                    modalDialog.alertType(response.code, response.msg, 'error', false);
                                }
                            });
                    };

                    /**
                     * [videoSplit 视频拆条]
                     *
                     * @param   {[type]}  item  [item description]
                     *
                     * @return  {[type]}        [return description]
                     */
                    $scope.videoSplit = function (item) {
                        mrApiService
                            .videoSplit({
                                mrType: $scope.basicalStatus.commonParams.mrType,
                                mainResourceType: $scope.basicalStatus.commonParams.mainResourceType,
                                relationId: item.relationid,
                            })
                            .then((response) => {
                                if (response.code === '200') {
                                    window.open(response.datas.qurl); // 打开拆条页面
                                } else {
                                    modalDialog.alertType(response.code, response.message, 'error', false);
                                }
                            });
                    };

                    /**
                     * [checkMaterial 智能机审]
                     *
                     * @return  {[type]}  [return description]
                     */
                    $scope.checkMaterial = function () {
                        let params = {
                            relationId: $scope.item.relationid
                        };
                        mrApiService.requestCensor(angular.extend(params, $scope.basicalStatus.commonParams)).then(function (data) {
                            if (data.code === '200') {
                                modalDialog.alertType('开始智能机审', data.datas.message, 'success', false, function () {
                                    $scope.item.checkstatus = 0;
                                });
                            }
                        });
                    };

                    /**
                     * [showLightGallery description]
                     *
                     * @param   {[type]}  item   [item description]
                     * @param   {[type]}  index  [index description]
                     *
                     * @return  {[type]}         [return description]
                     */
                    $scope.showLightGallery = function (item, index) {
                        var dynamicEl = [];
                        if (item.picturelist) {
                            item.picturelist.forEach((pic, ind) => {
                                dynamicEl[ind] = {
                                    src: pic.url || './static/picture_default.jpg',
                                    thumb: pic.url || './static/picture_default.jpg',
                                    subHtml: pic.title
                                };
                            });

                        } else {
                            dynamicEl = [{
                                src: item.thumbimg || './static/picture_default.jpg',
                                thumb: item.thumbimg || './static/picture_default.jpg',
                                subHtml: item.resourcetitle
                            }];
                        }
                        // dynamicEl = [{
                        //     src: item.thumbimg || './static/picture_default.jpg',
                        //     thumb: item.thumbimg || './static/picture_default.jpg',
                        //     subHtml: item.resourcetitle
                        // }];
                        $(this).lightGallery({
                            thumbnail: true,
                            dynamic: true,
                            dynamicEl: dynamicEl,
                            showThumbByDefault: false,
                            thumbWidth: 200,
                            thumbHeight: '200px',
                        });
                        $(this).on('onSlideItemLoad.lg', function (event, index) {
                            $('.new-img-wrap .lg-add-to-personal').remove();
                            if (item.thumbimg && item.mrtype !== 'personal') {
                                $('.new-img-wrap').prepend('<a class="lg-add-to-personal">添加到个人素材</a>');
                            }
                            $('a.lg-add-to-personal').click(() => {
                                addToPersonal(item, index, Number($('#lg-counter-current').text()) - 1);
                            });
                        });
                    };

                    /**
                * [addToPersonal description]
                * @param   {[type]}  item   [text description]
                * @param   {[type]}  index  [index description]
                * @param   {[type]}  text   [text description]
                *
                * @return  {[type]}         [return description]
                */
                    function addToPersonal(item, index, text) {
                        var descArr = item.resourceurl || item.thumbimg;
                        var newFileName = item.thumbimg.split('/');
                        mrApiService.addToPersonel(
                            {
                                mrType: 'personal',
                                mainResourceType: '0',
                                fileName: newFileName[newFileName.length - 1],
                                tempUrl: descArr
                            }
                        )
                            .then(function (data) {
                                if (data.code === '200') {
                                    modalDialog.alertType('添加成功', '', 'success', false);
                                    $window.document.getSelection().collapse($window.document, 1);
                                } else {
                                    modalDialog.alertType('', data.msg, 'error', false);
                                }
                            });
                    }

                    /**
                     * [openFilePreview description] 文件预览
                     * @param  {[type]} item  [description] 当前文件
                     * @param  {[type]} success [description] 回调函数
                     * @return {[type
                     *   ]}         [description]
                     */
                    function openFilePreview(item, success) {
                        var modalInstance = $modal.open({
                            templateUrl: './resourceCenter/materialResource/service/filePreview/filePreview_tpl.html',
                            windowClass: 'edit-iwo-personalMaterial-filePreview',
                            backdrop: false,
                            controller: 'personalMaterialFilePreviewCtrl',
                            resolve: {
                                item: function () {
                                    return item;
                                },
                            },
                        });
                        return modalInstance.result.then(function () {
                            success();
                        });
                    }
                },
            };
        },
    ])
    .filter('durationtrans', function () {
        return function (a) {
            var b = '';
            a = a / 1000;
            var h = parseInt(a / 3600),
                m = parseInt((a % 3600) / 60),
                s = parseInt((a % 3600) % 60);
            if (h > 0) {
                h = h < 10 ? '0' + h : h;
                b += h + ':';
            }
            m = m < 10 ? '0' + m : m;
            s = s < 10 ? '0' + s : s;
            b += m + ':' + s;
            return b;
        };
    });
